// features/LifecycleGuard.jsx
import { useEffect, useRef } from "react";
import { AppLifecycle as L } from "../utils/appLifecycle";

export default function LifecycleGuard() {
  const mountedRef = useRef(false);

  useEffect(() => {
    if (mountedRef.current) return;
    mountedRef.current = true;

    // 포그라운드 진입 시 하트비트 시작
    L.startHeartbeat();

    const onVisibility = () => {
      if (document.visibilityState === "hidden") {
        L.markBackground();
        L.stopHeartbeat();
      } else if (document.visibilityState === "visible") {
        // 복귀
        L.startHeartbeat();

        if (L.shouldHardReload()) {
          L.reloadWithCooldown("bg-timeout");
          return;
        }

        if (L.isStaleHeartbeat()) {
          L.reloadWithCooldown("stale-heartbeat");
          return;
        }

        // 우선 소프트 → 필요시 하드로 승격 (내부에서 재점검)
        L.stagedRecover("visibility");
        // bfcache가 아닐 때 기본 지연
        L.guardWhiteScreen({ delay: 2000 });
      }
    };

    const onPageShow = (e) => {
      // iOS bfcache 복귀 케이스도 커버
      L.startHeartbeat();

      if (L.shouldHardReload()) {
        L.reloadWithCooldown("pageshow-timeout");
        return;
      }
      if (L.isStaleHeartbeat()) {
        L.reloadWithCooldown("stale-heartbeat");
        return;
      }

      L.stagedRecover(e?.persisted ? "pageshow-bfcache" : "pageshow");
      // bfcache면 초기 페인트가 더 느릴 수 있어 지연 길게
      L.guardWhiteScreen({ delay: e?.persisted ? 2500 : 2000 });
    };

    const onPageHide = () => {
      L.markBackground();
      L.stopHeartbeat();
    };

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("pagehide", onPageHide);

    // 앱 최초 진입시 초기 가드 1회
    L.guardWhiteScreen({ delay: 2000 });

    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("pagehide", onPageHide);
      L.stopHeartbeat();
    };
  }, []);

  return null;
}
